import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext, useRef, useMemo } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { cloneElement } from '../_utils/reactNode';
import { tuple } from '../_utils/type';
export var PresetStatusColorTypes = tuple('success', 'processing', 'error', 'default', 'warning');
export var BadgeSizes = tuple('default', 'small');
var Badge = function Badge(props) {
  var _classNames, _context, _classNames2, _context2, _classNames3;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var badgeProps = getCompProps('Badge', userDefaultProps, props);
  var customPrefixcls = badgeProps.prefixCls,
    children = badgeProps.children,
    status = badgeProps.status,
    text = badgeProps.text,
    color = badgeProps.color,
    _badgeProps$count = badgeProps.count,
    count = _badgeProps$count === void 0 ? null : _badgeProps$count,
    _badgeProps$overflowC = badgeProps.overflowCount,
    overflowCount = _badgeProps$overflowC === void 0 ? 99 : _badgeProps$overflowC,
    _badgeProps$dot = badgeProps.dot,
    dot = _badgeProps$dot === void 0 ? false : _badgeProps$dot,
    _badgeProps$size = badgeProps.size,
    size = _badgeProps$size === void 0 ? 'default' : _badgeProps$size,
    title = badgeProps.title,
    offset = badgeProps.offset,
    style = badgeProps.style,
    className = badgeProps.className,
    _badgeProps$showZero = badgeProps.showZero,
    showZero = _badgeProps$showZero === void 0 ? false : _badgeProps$showZero,
    restProps = __rest(badgeProps, ["prefixCls", "children", "status", "text", "color", "count", "overflowCount", "dot", "size", "title", "offset", "style", "className", "showZero"]);
  var badgePrefixCls = getPrefixCls(prefixCls, 'badge', customPrefixcls); // 徽标数样式前缀
  // ================================ Misc ================================
  var numberedDisplayCount = count > overflowCount ? "".concat(overflowCount, "+") : count;
  var hasStatus = status !== null && status !== undefined || color !== null && color !== undefined;
  var isZero = numberedDisplayCount === '0' || numberedDisplayCount === 0;
  var isSingleNumber = !count || _typeof(count) !== 'object';
  var showAsDot = hasStatus || !isZero && dot;
  var mergedCount = showAsDot ? '' : numberedDisplayCount;
  var isHidden = useMemo(function () {
    var isEmpty = mergedCount === null || mergedCount === undefined || mergedCount === '';
    return (isEmpty || isZero && !showZero) && !showAsDot;
  }, [mergedCount, isZero, showZero, showAsDot]);
  var isDotRef = useRef(showAsDot);
  if (!isHidden) {
    isDotRef.current = showAsDot;
  }
  // =============================== Styles ===============================
  var mergedStyle = useMemo(function () {
    if (!offset) {
      return _extends({}, style);
    }
    var offsetStyle = {
      marginTop: offset[1]
    };
    offsetStyle.right = -parseInt(offset[0], 10);
    return _extends(_extends({}, offsetStyle), style);
  }, [offset, style]);
  // =============================== Render ===============================
  var badgeClassName = classNames(badgePrefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(badgePrefixCls, "-status"), hasStatus), _defineProperty(_classNames, "".concat(badgePrefixCls, "-not-a-wrapper"), !children), _classNames), className);
  var isDot = isDotRef.current;
  var scrollNumberCls = classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(badgePrefixCls, "-dot"), isDot), _defineProperty(_classNames2, "".concat(badgePrefixCls, "-count"), !isDot), _defineProperty(_classNames2, "".concat(badgePrefixCls, "-count-sm"), size === 'small'), _defineProperty(_classNames2, "".concat(badgePrefixCls, "-multiple-words"), !isDot && mergedCount && mergedCount.toString().length > 1), _defineProperty(_classNames2, _concatInstanceProperty(_context = "".concat(badgePrefixCls, "-status-")).call(_context, status), !!status), _classNames2));
  var statusCls = classNames((_classNames3 = {}, _defineProperty(_classNames3, "".concat(badgePrefixCls, "-status-dot"), hasStatus), _defineProperty(_classNames3, _concatInstanceProperty(_context2 = "".concat(badgePrefixCls, "-status-")).call(_context2, status), !!status), _classNames3));
  var statusStyle = {};
  if (color) {
    statusStyle.background = color;
  }
  // Title
  var titleNode = title !== null && title !== void 0 ? title : typeof count === 'string' || typeof count === 'number' ? count : undefined;
  // Status Text
  var statusTextNode = isHidden || !text ? null : /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-status-text")
  }, text);
  // Display Component
  var displayNode = isSingleNumber ? /*#__PURE__*/React.createElement("sup", {
    className: scrollNumberCls,
    style: _extends(_extends({}, mergedStyle), {
      backgroundColor: color
    }),
    title: titleNode
  }, mergedCount) : cloneElement(count, function (oriProps) {
    return {
      style: _extends(_extends({}, mergedStyle), oriProps.style),
      className: classNames("".concat(badgePrefixCls, "-custom-component"), oriProps === null || oriProps === void 0 ? void 0 : oriProps.className)
    };
  });
  if (!children && hasStatus) {
    var statusTextColor = mergedStyle.color;
    return /*#__PURE__*/React.createElement("span", _extends({}, restProps, {
      className: badgeClassName,
      style: mergedStyle
    }), /*#__PURE__*/React.createElement("span", {
      className: statusCls,
      style: statusStyle
    }), /*#__PURE__*/React.createElement("span", {
      style: {
        color: statusTextColor
      },
      className: "".concat(badgePrefixCls, "-status-text")
    }, text));
  }
  return /*#__PURE__*/React.createElement("span", _extends({}, restProps, {
    className: badgeClassName
  }), children, !isHidden && displayNode, statusTextNode);
};
Badge.displayName = 'Badge';
export default Badge;